module.exports = __webpack_public_path__ + "assets/images/img/onboarding_3.766cedfad6168d0def95930e4f33c038.png";